import React, { useState, useRef } from "react";
import uploadIcon from "../../assets/images/upload.svg";
// import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import StorageHelper from "../../Utility/StorageHelper";
import { upsertKycEnabledFarmers } from "../../Utility/Utils";
import { useHistory } from "react-router-dom";
import ExcelJS from "exceljs";
import {
  NO_ENTRIES_TOAST_MESSAGE,
  TEMPLATE_HREF,
} from "./constants";
import {
  FarmerKycUploadRow,
  parseWorksheetToRows,
  rowsToKycEnablePayload,
} from "./utils";

export default function FarmerKycEnablePage() {
  const [uploadedData, setUploadedData] = useState<FarmerKycUploadRow[]>([]);
  const [fileName, setFileName] = useState("");
  const history = useHistory();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const buffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        toast.error("No sheet found in the Excel file.");
        return;
      }

      const rows = parseWorksheetToRows(worksheet);

      if (rows.length > 0) {
        setUploadedData(rows);
        setFileName(file.name);
      } else {
        toast.error("No data found in the Excel file.");
        setUploadedData([]);
        setFileName("");
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error parsing file:", error);
      toast.error("Could not read the Excel file.");
      setUploadedData([]);
      setFileName("");
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleRemoveFile = () => {
    setFileName("");
    setUploadedData([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSave = async (data: FarmerKycUploadRow[]) => {
    try {
      if (!Array.isArray(data) || data.length === 0) {
        throw new Error("No rows to save");
      }

      const authData = JSON.parse(StorageHelper.get("auth") || "{}");
      const payload = rowsToKycEnablePayload(data);

      const raw: any = await upsertKycEnabledFarmers(payload, {
        jwtToken: authData.jwtToken,
        userId: authData.userId,
      });

      const failed =
        raw != null &&
        typeof raw === "object" &&
        !Array.isArray(raw) &&
        raw.success === false;

      if (failed) {
        toast.error(raw.message || raw.error || "Request failed", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        return;
      }

      const noEntriesAdded =
        raw != null &&
        typeof raw === "object" &&
        !Array.isArray(raw) &&
        raw.success === true &&
        raw.data === false;

      if (noEntriesAdded) {
        toast.error(NO_ENTRIES_TOAST_MESSAGE, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        return;
      }

      toast.success("New Entries Added Successfully.", {
        position: toast.POSITION.TOP_CENTER,
        style: { backgroundColor: "#258750", color: "white" },
        autoClose: 3000,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error: any) {
      console.error(error);
      const body = error?.response?.data;
      const msg =
        (typeof body === "string" ? body : body?.message || body?.error) ||
        error?.message ||
        "Something went wrong";
      toast.error(msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="p-5">
      <div className="block sm:flex items-center">
        <h1 className="text-xl font-bold px-3 py-3">Farmer KYC Enable</h1>
      </div>
      <hr className="mt-4 border border-gray-200" />

      <>
        <div className="mt-10">
          <div className="flex justify-center mt-0">
            <div
              className={`border-2 border-dashed border-opacity-50 border-gray-400 ${uploadedData?.length === 0 ? `bg-white` : `bg-green-300`
                } flex flex-col justify-center items-center px-28 py-12`}
            >
              <input
                type="file"
                ref={fileInputRef}
                id="farmerKycFileInput"
                accept=".xlsx"
                className="hidden"
                onChange={handleFileUpload}
              />
              <img
                src={uploadIcon}
                alt="Bulk Upload Img"
                className="cursor-pointer"
                onClick={() => document.getElementById("farmerKycFileInput")?.click()}
              />
              {fileName !== "" && (
                <div>
                  <span className="text-wrap w-2">{fileName}</span>
                  <span
                    className="cursor-pointer text-2xl text-red-500 ml-2"
                    onClick={() => {
                      handleRemoveFile();
                    }}
                  >
                    x
                  </span>
                </div>
              )}

              <p
                id="farmerKycInputName"
                className="text-[#009CA7] cursor-pointer font-semibold mt-4 text-base"
                onClick={() => {
                  handleRemoveFile();
                  document.getElementById("farmerKycFileInput")?.click();
                }}
              >
                {uploadedData?.length === 0 ? "Upload File" : "Replace File"}
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center mt-7">
          <h1 className="text-base">
            Use csv format, or{" "}
            <a
              href={TEMPLATE_HREF}
              className="text-[#009CA7] font-bold"
              download
            >
              Download Template
            </a>
          </h1>
        </div>
      </>

      <div className="flex fixed bottom-6 left-16 right-0 justify-center items-center gap-10 sm:gap-96">
        <button
          className="flex px-6 py-1.5 border-2 border-grey-300 rounded-md bg-white mr-4"
          onClick={() => {
            history.push("/about");
          }}
        >
          Cancel
        </button>
        <button
          disabled={uploadedData?.length === 0}
          className={`flex px-8 py-1.5 border-2 border-grey-300 rounded-md text-white ${uploadedData?.length === 0 ? `bg-gray-400` : `bg-[#009CA7]`
            } `}
          onClick={() => handleSave(uploadedData)}
        >
          Save
        </button>
      </div>
    </div>
  );
}
